/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../TextEditorAPI'
], function(APIFactory, TextEditorAPI){
	class TextEditor{
		constructor(options){
			this._customColor = options.features['Dashboard.CustomColor'];
			this.titles = [];
		}

		initialize() {
			this._customColor.registerProvider(this);
		}

		destroy() {
			if (this._customColor) {
				this._customColor.deregisterProvider(this);
			}
		}

		getCustomColorList() {
			return this.titles.reduce((accumulator, currentValue) => {
				return accumulator.concat(currentValue.textEditor.getCustomColorList());
			}, []);
		}

		getAPI() {
			return APIFactory.createAPI(this, [TextEditorAPI]);
		}

		registerProvider(title) {
			this.titles.push(title);
		}
	}

	return TextEditor;
});
